import { Link } from "@inertiajs/react";
import { Button } from "@/components/ui/Button";
import { RuneConstellation } from "@/components/ui/art";

export function Hero() {
  return (
    <header
      className="relative isolate overflow-hidden flex items-center"
      style={{
        minHeight: "min(86dvh, 740px)",
        backgroundColor: "var(--color-hero-stage)",
      }}
    >
      {/* Decorative art — the glowing runic ᛗ constellation */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10"
      >
        <RuneConstellation
          count={1000}
          center={{ x: 0.66, y: 0.5 }}
          scale={0.9}
          coreFraction={1.0}
          ambientCount={200}
          className="opacity-100 sm:opacity-100"
        />
      </div>

      {/* Left→right legibility scrim — heavy on copy column, fades out right */}
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10"
        style={{
          background:
            "linear-gradient(90deg, rgba(var(--raw-hero-stage),0.92) 0%, rgba(var(--raw-hero-stage),0.66) 34%, rgba(var(--raw-hero-stage),0.18) 62%, rgba(var(--raw-hero-stage),0) 82%)",
        }}
      />

      <div
        className="w-full max-w-5xl mx-auto px-4 sm:px-8"
        style={{
          paddingTop: "clamp(54px, 8vw, 90px)",
          paddingBottom: "clamp(54px, 8vw, 90px)",
        }}
      >
        <div style={{ maxWidth: "600px" }}>
          {/* Eyebrow */}
          <span
            className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.14em] mb-6"
            style={{ color: "var(--color-hero-accent)" }}
          >
            <span
              className="block w-7 opacity-80"
              style={{ height: "1px", background: "var(--color-hero-accent)" }}
            />
            Learn by reading
          </span>

          {/* Headline */}
          <h1
            className="font-serif font-normal leading-[1.04] tracking-[-0.018em] mb-6 text-wrap-balance"
            style={{
              fontSize: "clamp(40px, 5.6vw, 70px)",
              color: "var(--color-hero-ink)",
            }}
          >
            A language is best learned by{" "}
            <em
              style={{ fontStyle: "italic", color: "var(--color-hero-accent)" }}
            >
              reading
            </em>{" "}
            it.
          </h1>

          {/* Lede */}
          <p
            className="font-serif leading-[1.55] mb-9 max-w-[42ch] text-wrap-pretty"
            style={{
              fontSize: "clamp(17px, 1.5vw, 20px)",
              color: "var(--color-hero-muted)",
            }}
          >
            Real texts, gently glossed. Tap any word for instant meaning, and
            let it settle into memory at its own pace. No streaks, no points —
            just you and the page.
          </p>

          {/* CTAs */}
          <div className="flex items-center gap-6 flex-wrap">
            <Button variant="filled" href="/users/sign_up">
              Start reading
            </Button>
            <Link
              href="/users/sign_in"
              className="inline-flex items-center min-h-11 font-serif text-base transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded-sm"
              style={{ color: "var(--color-hero-ink)" }}
            >
              <span
                className="border-b pb-0.5"
                style={{ borderColor: "var(--color-hero-line)" }}
              >
                I already have an account
              </span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
